import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  QueryList,
  ViewChildren,
} from '@angular/core';
import { MatTooltip } from '@angular/material/tooltip';
import { Router } from '@angular/router';

import { SubscriptionPlan } from '@vi-iot/client';

import {
  AuthStore,
  BookingPlansLoadingState,
  BookingStore,
  noInstallationsError,
  Platform,
  RemoteConfigStore,
} from '@store';

import { matTooltipSetter } from '../../shared/functions/mat-tooltip-setter/mat-tooltip-setter';
@Component({
  selector: 'app-booking-plans',
  templateUrl: './booking-plans.component.html',
  styleUrls: ['./booking-plans.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BookingPlansComponent implements OnInit {
  BookingPlansLoadingState = BookingPlansLoadingState;
  @ViewChildren(MatTooltip)
  set matTooltip(queryList: QueryList<MatTooltip>) {
    matTooltipSetter(queryList);
  }

  @Input() selectedPlatform: Platform;
  @Input({ required: true }) isBoilerSerialInQuery: boolean;

  @Output() planSelected = new EventEmitter();
  @Output() navigateToCheckout = new EventEmitter();

  isLegacyDevice: boolean;
  BookingPlans = SubscriptionPlan;
  noInstallationsError = noInstallationsError;
  constructor(
    public bookingStore: BookingStore,
    public remoteConfigStore: RemoteConfigStore,
    public authStore: AuthStore,
    private router: Router
  ) {}

  ngOnInit(): void {
    this.isLegacyDevice = this.selectedPlatform === Platform.Legacy;
    this.bookingStore.fetchSubscriptionsPlans();
    this.bookingStore.getTrialSubscriptions();
    this.bookingStore.getAllVitoguideSubscriptions();
  }

  selectPlan(plan: SubscriptionPlan): void {
    this.bookingStore.selectPlan(plan);
    if (!!this.selectedPlatform && this.isBoilerSerialInQuery) {
      this.navigateToCheckout.emit();
    } else {
      this.planSelected.emit();
    }
  }

  goToInstallations(): void {
    this.router.navigate(['/installations']);
  }
}
